import type { ReactNode } from 'react';
import { Svg } from '../primitives/Svg.js';
import type { IconProps } from '../primitives/types.js';

/** Layout grid — four cells used for grid/list view toggles. */
export function IcnLayoutGrid(props: IconProps): ReactNode {
  return (
    <Svg {...props} iconName="layout-grid">
      <rect x="2.5" y="2.5" width="4" height="4" rx="0.8" />
      <rect x="9.5" y="2.5" width="4" height="4" rx="0.8" />
      <rect x="2.5" y="9.5" width="4" height="4" rx="0.8" />
      <rect x="9.5" y="9.5" width="4" height="4" rx="0.8" />
    </Svg>
  );
}
